package pl.michal_cyran.brand_hub.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.dom.Div

@Composable
fun DeviceMockup(
    imageName: String,
) {
    val color = if (ColorMode.current.isDark) "dark" else "light"
    val imagePath = "${imageName}_$color.png"

    Div(
        Modifier
            .classNames("device-wrapper")
            .toAttrs()
    ) {
        Div(
            Modifier
                .classNames("device")
                .attr("data-device", "Pixel")
                .attr("data-orientation", "portrait")
                .attr("data-color", "black")
                .toAttrs()
        ) {
            Div(
                Modifier
                    .classNames("screen")
                    .toAttrs()
            ) {
                Image(
                    imagePath,
                    modifier = Modifier
                        .objectFit(ObjectFit.Cover)
                        .fillMaxWidth()
                        .fillMaxHeight()
                )
            }
        }
    }
}